module.exports = __webpack_public_path__ + "static/media/LinkedIn.44df3dbe.svg";